import React from 'react';
import PropTypes from 'prop-types';
import colors from '../../../constants/colors';

class SortArrow extends React.Component {
  render(){
    let bottomFill = this.props.bottomFill && this.props.selected;
    let topFill = this.props.topFill && this.props.selected;

    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8.081632653061227"
        height="15.48979591836735"
      >

        <rect
          id="backgroundrect"
          width="100%"
          height="100%"
          x="0"
          y="0"
          fill="none"
          stroke="none"
          className=""
        />

        <g>
          <rect
            x="-1"
            y="-1"
            width="25"
            height="46"
            id="canvas_background"
            fill="none"
          />
          <g
            id="canvasGrid"
            display="none"
          >
            <rect
              id="svg_1"
              width="10"
              height="26"
              x="1"
              y="1"
              strokeWidth="0"
              fill="url(#gridpattern)"
            />
          </g>
        </g>
        <g
          className="currentLayer"
        >
          <path
            fill={colors.gray1}
            stroke={colors.black}
            strokeWidth="0"
            strokeOpacity="null"
            opacity="0.5"
            d="m142.5,23 "
            id="svg_9"
            className=""
          />
          <g
            stroke="null"
            id="svg_10"
            className=""
          >
            <g
              stroke="null"
              id="svg_2"
            >
            {/* Up and Down arrows */}
              <path
                stroke={colors.white}
                fill={
                  topFill ? colors.green : colors.gray1
                }
                strokeWidth="0"
                d="m0.020408108830451875,7.056503282087565 l4.067272693236768,-7.117727832096338 l4.067272693236768,7.117727832096338 l-8.134545032798112,0 z"
                id="svg_6"
              />
              <path
                stroke={colors.black}
                fill={
                  bottomFill ? colors.green : colors.gray1
                }
                strokeWidth="0"
                strokeOpacity="null"
                d="m8.154953848979414,8.299279114074945 l-4.067272693236768,7.117727832096338 l-4.0672723395613435,-7.117727832096338 l8.134545032798112,0 z"
                id="svg_8"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

SortArrow.propTypes = {
  selected: PropTypes.bool.isRequired,
  topFill: PropTypes.bool.isRequired,
  bottomFill: PropTypes.bool.isRequired
};

export default SortArrow;
